// 模板代码块
/* <div :class="['j-gis-map-layout', currentMeasureType]">
    <div class="j-gis-map" :id="mapRandomId" v-bind="$attrs"/>
    <j-gis-coord v-if="showCoordinate" :point="coordinateTarget" /> // 如果不需要测量工具模块，可移除
    <slot name="control" /> // 如果不需要嵌套工具栏可移除
 </div> */

// 基本样式代码块
/* .j-gis-map-layout {
  position: relative;
  height: 100%;
  width: 100%;
}
.j-gis-map-layout.coordinate{
  cursor: cell;
}
.j-gis-map-layout .j-gis-map{
  height: 100%;
  width: 100%;
}
.j-gis-map-layout .j-gis-map .esri-zoom{
  display: none;
}
.esri-view .esri-view-surface--inset-outline:focus::after {
  display: none;
} */

export default {
  async created () {
    await this.createMap()
    this.GisMapMoveCenter()
    this.GisMapLoadComplete()
  },
  methods: {
    // -------------- 状态操作--------------
    // 隐藏control控件菜单
    GisMapHideControlMenu () {
      this.$slots.control && this.$slots.control[0] && this.$slots.control[0].componentInstance.CtrlPopupHide()
    },
    // 统一的事件触发重置状态函数
    GisMapEventResetStatus (event) {
      // 清除坐标计算弹窗
      if (this.currentMeasureType === 'coordinate') this.clearMapMeasure()
      this.currentMeasureType = ''
    },
    // -------------- 状态操作--------------

    // -------------- 点位操作--------------
    // 地图移动到选中点并高亮
    GisMapDrawActivePoint (point) {
      console.log(point)
      this.graphicsActiveLayer && this.graphicsActiveLayer.removeAll()
      if (!point) return
      let url = require('../assets/point-light.png')
      const graphic = new this.gisConstructor.Graphic({
        geometry: {
          type: 'point',
          x: point.longitude || point.x || 0,
          y: point.latitude || point.y || 0,
          spatialReference: this.view.spatialReference
        },
        symbol: {
          type: 'picture-marker',
          url, // 图标地址
          width: '44px',
          height: '44px'
        },
        attributes: {
          meta: { ...point, isActive: true }
        }
      })
      this.graphicsActiveLayer.add(graphic)
      this.GisMapMovePoint(point)
    },
    // 地图画组合点位，多个图片文字组合成一个点位(moveCenter是否设置为中心点)
    async GisMapDrawGroupPoint (point = {}, moveCenter = false) {
      let pointImg = require('../assets/point.png') // 下方点位图片
      let descImg = require('../assets/gis-point.png') // 上方点位图片
      // let descImg = await this.ToolImageHandleFillets(point.AVATAR) // 图像裁剪成圆形
      let uuid = `${Date.now()}${parseInt(Math.random() * 100)}`
      let attributes = { id: uuid, meta: { ...point }, isGroup: true }
      let geometry = new this.gisConstructor.Point((point.longitude || point.x || 0), (point.latitude || point.y || 0), this.view.spatialReference)

      const pointGraphic = new this.gisConstructor.Graphic({
        geometry,
        symbol: { type: 'picture-marker', url: pointImg, width: '44px', height: '44px' },
        attributes
      })

      const textGraphic = new this.gisConstructor.Graphic({
        geometry,
        symbol: { type: 'text',
          color: '#456BEA',
          // haloColor: '#466BED', 外边框颜色
          // haloSize: '1px', 外边框宽度
          text: point.name || point.text || '点位文字',
          xoffset: 0,
          yoffset: 16,
          font: {
            size: 11
            // weight: 'bold'
          }
        },
        attributes
      })

      const descGraphic = new this.gisConstructor.Graphic({
        geometry,
        symbol: {
          type: 'picture-marker',
          url: descImg,
          width: '40px',
          height: '40px',
          yoffset: 44
        },
        attributes
      })

      // 符号组 --点击事件如果想同时处理一组graphic，通过循环判断id的方式，找到同一组graphic处理
      const graphicGroup = { id: uuid, graphics: [ pointGraphic, textGraphic, descGraphic ] }
      this.groupGraphicMap[uuid] = graphicGroup

      this.graphicsLayer.add(pointGraphic)
      this.graphicsLayer.add(textGraphic)
      this.graphicsLayer.add(descGraphic)
      moveCenter && this.GisMapMovePoint(point)
    },
    // 地图画点位(moveCenter是否设置为中心点)
    GisMapDrawPoint (point = {}, moveCenter = false) {
      let url = require('../assets/gis-point.png')
      // eslint-disable-next-line eqeqeq
      // if (point.status == 0) {
      //   url = require('../assets/point.png')
      //   // eslint-disable-next-line eqeqeq
      // }
      const graphic = new this.gisConstructor.Graphic({
        geometry: {
          type: 'point',
          x: point.longitude || point.x || 0,
          y: point.latitude || point.y || 0,
          spatialReference: this.view.spatialReference
        },
        symbol: {
          type: 'picture-marker',
          url, // 图标地址
          width: '28px',
          height: '28px'
        },
        attributes: {
          meta: { ...point }
        }
      })
      this.graphicsLayer.add(graphic)
      moveCenter && this.GisMapMovePoint(point)
    },
    // 通过数组渲染所有点位 ['simple', 'group']单个点、组合点
    GisMapRenderPointArray (pointArr = [], type = 'simple') {
      this.GisMapClearPoint()
      if (type === 'group') return pointArr.forEach((point, i) => this.GisMapDrawGroupPoint(point, i === 0))
      pointArr.forEach((point, i) => this.GisMapDrawPoint(point, i === 0))
    },
    // 移动到地图默认的中心点
    GisMapMoveCenter () {
      this.GisMapMovePoint()
    },
    // 移动到指定点
    GisMapMovePoint (point = {}) {
      const { longitude, latitude, x, y } = point
      const geometry = {
        type: 'point',
        longitude: longitude || x || this.gisConfig.default.longitude,
        latitude: latitude || y || this.gisConfig.default.latitude,
        spatialReference: this.SR.wkid
      }
      this.view.center = geometry
    },
    // 清除图标点位
    GisMapClearPoint () {
      this.graphicsLayer && this.graphicsLayer.removeAll()
      this.graphicsActiveLayer && this.graphicsActiveLayer.removeAll()
    },
    // -------------- 点位操作--------------

    // -------------- 事件注册--------------
    // 地图初始化加载完成
    GisMapLoadComplete () {
      this.$emit('load')
    },
    // 地图点击事件
    GisMapClick (event) {
      if (this.currentMeasureType === 'coordinate') return this.computeCoordinate(event)
      this.$emit('click', event)
    },
    // 地图失去焦点事件
    GisMapBlur (event) { this.$emit('blur', event) },
    // 地图双击事件
    GisMapDoubleClick (event) {
      this.GisMapEventResetStatus(event)
      this.$emit('db-click', event)
    },
    // 地图聚焦事件
    GisMapFocusClick (event) { this.$emit('focus', event) },
    // 地图鼠标滚轮事件
    GisMapMouseWheel (event) {
      this.GisMapEventResetStatus(event)
      this.$emit('mouse-wheel', event)
    },
    // 地图拖拽、移动事件
    GisMapDrag (event) {
      this.GisMapEventResetStatus(event)
      this.$emit('drag', event)
    },
    // 视图点击事件（只返回包含点位的点击事件）
    GisMapLayerClick (event) {
      if (event.results.length > 0) {
        let points = event.results.map(item => item.graphic.attributes)
        this.$emit('hit', points)
      }
    },
    // -------------- 事件注册--------------

    // -------------- 地图切换--------------
    // 显示电子地图
    GisMapShowElectronMap () {
      this.GisMapHideControlMenu()
      if (!this.mapLayerMap['电子地图']) this.buildMapLayer()
      this.showLayerById('电子地图')
    },
    // 显示影像地图
    GisMapShowSimulationMap () {
      this.GisMapHideControlMenu()
      if (!this.mapLayerMap['影像地图']) this.buildMapLayer()
      this.showLayerById('影像地图')
    },
    // -------------- 地图切换--------------

    // -------------- 拓展图层模块--------------
    // 显示拓展图层 - 网格
    GisMapToggleExpandGridLayer (toggle = true) {
      if (!this.operationLayerMap) return console.error('未引入[layerMixins]')
      if (!this.operationLayerMap['网格']) return console.error(`json配置文件operationalLayers节点中未定义['网格']`)
      this.operationLayerMap['网格'].visible = toggle
    },
    // 获取行政区划数组
    GisMapGetExpandSubjectLayer () {
      if (!this.operationLayerMap) return console.error('未引入[layerMixins]')
      if (this.geoserver) return this.operationLayerMap
      this.createOperationSublayerMap(this.operationLayerMap['行政区划'])
      return this.operationSublayerMap
    },
    // 显示行政区划图层 - 传参规则参照operationSublayerMap映射key 例：'区', '街办', '社区'
    GisMapToggleExpandSubjectLayer (toggle = true, subject) {
      if (!this.operationSublayerMap) return console.error('未引入[layerMixins]')
      if (this.geoserver) {
        if (this.operationLayerMap[subject]) return this.operationLayerMap[subject].visible = toggle
        else console.error(`json配置文件operationalLayers节点中未定义[${subject}]`)
      }
      if (!this.operationSublayerMap[subject]) this.createOperationSublayerMap(this.operationLayerMap['行政区划'])
      if (!this.operationSublayerMap[subject]) return console.error(`json配置文件operationalLayers节点['行政区划']无对应['${subject}'的服务]`)
      console.log(Object.keys(this.operationSublayerMap))
      this.operationSublayerMap[subject].visible = toggle
    },
    // -------------- 拓展图层模块--------------

    // -------------- 测量工具模块--------------
    // 测量面积
    GisMapToolMeasureArea () {
      this.GisMapHideControlMenu()
      if (!this.measureArea) return console.error('未引入[measureMixins]')
      this.measureArea()
    },
    // 测量坐标
    GisMapToolMeasureCoordinate () {
      this.GisMapHideControlMenu()
      if (!this.measureCoordinate) return console.error('未引入[measureMixins]')
      this.measureCoordinate()
    },
    // 测量距离
    GisMapToolMeasureDistance () {
      this.GisMapHideControlMenu()
      if (!this.measureDistance) return console.error('未引入[measureMixins]')
      this.measureDistance()
    },
    // 清除测量结果
    GisMapClearMeasure () {
      if (!this.clearMapMeasure) return console.error('未引入[measureMixins]')
      this.clearMapMeasure()
    },
    // -------------- 测量工具模块--------------

    // -------------- 资源绘图模块--------------
    // 根据半径画圆范围
    GisMapDrawGraphicCircleRange (centerPoint, radius) {
      const { lon, lat, longitude, latitude, x, y } = centerPoint
      const center = new this.gisConstructor.Point(x || longitude || lon, y || latitude || lat, this.SR)
      const geometry = new this.gisConstructor.Circle({ center, radius, radiusUnit: 'meters' })
      const symbol = {
        type: 'simple-fill', // autocasts as SimpleFillSymbol
        style: 'solid',
        color: [64,158,255, 0.1],
        outline: {
          color: [64,158,255, 0.1],
          width: 1
        }
      }
      const graphic = new this.gisConstructor.Graphic({ geometry, symbol })
      this.drawResourceLayer.add(graphic)
    },
    // 画点、线、面操作
    GisMapDrawGraphicResources (type) {
      // type: point, polygon, polyline
      this.GisMapHideControlMenu()
      if (!this.startResourceDraw) return console.error('未引入[drawMixins]')
      this.startResourceDraw(type)
    },
    // 绘制区域内查询是否包含当前点位(需要先使用GisMapDrawGraphicResources绘制)
    async GisMapGraphicBufferSearch (node) {
      if (!this.queryBufferGeometry) return console.error('未引入[drawMixins]')
      return this.queryBufferGeometry(node)
    },
    // 获取绘制区域的点位信息及区域代码片段(需要先使用GisMapDrawGraphicResources绘制)
    GisMapGetGraphicStorage () {
      if (!this.storageGeometryPoint) return console.error('未引入[drawMixins]')
      if (!this.completeGeometry) return console.error('[startResourceDraw]未执行绘画函数,请先绘画')
      return this.storageGeometryPoint()
    },
    // 清除绘制区域
    GisMapClearGraphicResources () {
      if (!this.clearResourceDraw) return console.error('未引入[drawMixins]')
      this.clearResourceDraw()
    },
    // 渲染根据Polygon字符串渲染形状
    GisMapRenderPolygon (polygonString) {
      if (!this.renderPolygonString) return console.error('未引入[drawMixins]')
      this.renderPolygonString(polygonString)
    },
    // -------------- 资源绘图模块--------------

    // -------------- 地图查询模块--------------
    // 地图查询点位信息 (返回promise对象) point: 带经纬度的点位参数 fields: 需要返回字段的数组
    async GisMapQueryTask (point, fields) {
      if (!this.queryTask) return console.error('未引入[queryMixins]')
      return this.startQueryTask(point, fields)
    }
    // -------------- 地图查询模块--------------
  }
}
